import { render } from "./categoryKnowledge.vue?vue&type=template&id=16efcd76"
import script from "./categoryKnowledge.vue?vue&type=script&lang=js"
export * from "./categoryKnowledge.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__